import { schema } from 'normalizr';

const pulseSurveyPeriodSchema = new schema.Entity('pulseSurveyPeriods', {});

export default pulseSurveyPeriodSchema;
